import React from 'react';
export function PainHook() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-51" data-mp="3hfpi4ixvwvl2">
      <div className="mx-auto grid max-w-6xl items-start gap-10 px-5 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-52" data-mp="3am1o2bq5tes6">
        <div data-id="element-53" data-mp="2wtc227ams9v2">
          <h2 className="text-2xl font-black leading-tight tracking-tight text-ink sm:text-[2.1rem]" data-id="element-54" data-mp="2wtlppo87e4xl">
            ¿Has sentido esa frustración de pasar 3 horas peinando a tu hijo… solo para
            encontrar un piojo vivo a la mañana siguiente?
          </h2>

          <div className="mt-6 space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-55" data-mp="2rvtr6bd1zkkf">
            <p data-id="element-56" data-mp="2dvj0b8bqu5z9">
              <strong className="font-bold text-ink" data-id="element-57" data-mp="2dw11mjd9jae1">No es tu culpa.</strong> Los champús
              de farmacia ya no funcionan porque los piojos mutaron para volverse inmunes
              a los químicos. Estás aplicando venenos en la cabeza de tus hijos que ellos
              simplemente… ignoran.
            </p>
            <p className="border-l-4 border-flame pl-5 font-semibold text-ink" data-id="element-58" data-mp="g4q3uizsuo4n">
              Es hora de dejar de lavar sábanas a medianoche y de tirar el dinero en
              productos obsoletos.
            </p>
          </div>
        </div>

        <aside className="rounded-2xl bg-paper-soft p-7" data-id="element-59" data-mp="1no03h1880nh3">
          <p className="text-6xl font-black leading-none tracking-tighter text-alarm sm:text-7xl" data-id="element-60" data-mp="22dfgzfiqqweu">
            98%
          </p>
          <p className="mt-3 text-base font-semibold leading-snug text-ink" data-id="element-61" data-mp="1xhqotx91whsk">
            de los piojos ya son resistentes a los insecticidas de venta libre.
          </p>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/4e70a30c-d44f-4cfe-b01a-d635b892d0ed.jpg" alt="Peine metálico de dientes finos junto a un recipiente de aceite y lavanda" className="mt-6 h-44 w-full rounded-xl object-cover" data-id="element-62" data-mp="14s9z57ctff01" />
          <p className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-63" data-mp="2v235djyse1wm">
            La solución no es un químico más fuerte. Es un mecanismo físico que el piojo
            no puede desarrollar inmunidad contra: la asfixia biológica.
          </p>
        </aside>
      </div>
    </section>;
}